<template>
	<div class="cart">
		<empty v-if="empty"/>
		<items v-else/>
		<bottom/>
	</div>
</template>

<script>
import items from "./items/index.vue";
import bottom from "./bottom.vue";
import empty from "./empty.vue";

export default {
	components: {items, bottom, empty},
	computed: {
		empty: (t) => !t.$store.getters["cart/items"].length,
		minicart: (t) => t.$store.getters["cart/minicart"]
	}
};
</script>

<style lang="scss" scoped>
.cart {
	border-bottom: 1px solid black;
	background-color: #636464;
	width: $minicart;
	position: fixed;
	top: $header;
	bottom: 0;

	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
</style>
